
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.148 1.883V.797h3.336c.651 0 1.206.057 1.664.172.464.11.85.284 1.157.523.208.156.403.35.586.578.296.36.52.787.671 1.282.183.572.274 1.237.274 1.992 0 1.187-.177 2.101-.531 2.742-.354.64-.826 1.12-1.414 1.437-.589.318-1.435.477-2.54.477H.149V8.914H3.36c.547 0 .985-.031 1.313-.094.333-.067.601-.169.805-.304.208-.141.393-.329.554-.563a2.82 2.82 0 00.39-.875c.095-.344.155-.737.18-1.18H.149V4.813h6.438c-.031-.5-.107-.925-.227-1.274a2.484 2.484 0 00-.507-.906 1.99 1.99 0 00-.883-.563c-.365-.125-.87-.187-1.516-.187H.148z","fill":"currentColor"}})])
          )
        }
      }
    